import {
  getActionNameWithStatus,
  getResetAction,
} from "../../constants/actions-methods";
import { requestStatus } from "../../constants/request";
import { serverApis } from "../../constants/server-apis";

export const accountPeriodCodeReducer = (state = "", action) => {
  const actionName = serverApis.getAccountPeriodCode.actionName;
  switch (action.type) {
    case getActionNameWithStatus(actionName, requestStatus.SUCCESS):
      return action.json.account_period.code;

    case getResetAction(actionName):
      return "";
    default:
      return state;
  }
};
